// @flow
import { makeGetRequest } from '../utils'

import type { ResponseAPI } from '../types/api'
import type { Country } from '../types/countries'

export const getRadioChannelCountries = (domain: string, serviceSpec: string): Promise<ResponseAPI<Country>> =>
  makeGetRequest(`${domain}/client/api/servicespec/${serviceSpec}/radio/countries`)
